<template>
  <v-container fluid class="container-full-bg-transaparent">
    <!--<v-row v-if="permission.can_write">
      <v-col cols="12" sm="12" :md="showRules || !horizontal_effects_view ? '8': '12'" :lg="showRules || !horizontal_effects_view? '8': '12'" :xl="showRules || !horizontal_effects_view? '8': '12'">
    -->
    <app-multipane class="split-panes" v-if="permission.can_write">
      <div class="pane" :style="{ minWidth: '200px', width: $vuetify.breakpoint.mdAndUp ? '75%' : '100%', flexGrow: showRules || !horizontal_effects_view ? '0': '1'}">
        <bank-account-detail v-if="currentCompany" :company_id="currentCompany.id" :bank_account_id="bank_account_id"
          :selectedEffects="selectedEff" :selectedTransactionsP="selectedTr"
          :classes="((showRules && ((currentBankAccount && !currentBankAccount.work_with_effects) || currentBankAccount && currentBankAccount.work_with_effects && !horizontal_effects_view)) || (!showRules && currentBankAccount && currentBankAccount.work_with_effects && !horizontal_effects_view)) ? 'full-min-height': ''"
          @updateE="handleSelectedEffects" @updateT="handleSelectedTransactions"
          @toggleShowRules="toggleShowRules" 
          @refreshListEffects="handleRefreshEffects"
          @updateWorkWithEffects="setEffectsVisibility"
          />
        <bank-pending-effects-table
          v-if="got_feature('feature_can_use_payable_or_receivable_effects') && currentBankAccount && currentBankAccount.work_with_effects && horizontal_effects_view"
          :selectedEffects="selectedEff" :selectedTransactionsP="selectedTr"
          @updateE="handleSelectedEffects" @updateT="handleSelectedTransactions"
          class="mt-2" @toggleSplitView="toggleSplitView"
          ref="pendingEffectsTable"></bank-pending-effects-table>          
      </div>
      <app-multipane-resizer v-if="showRules || !horizontal_effects_view"></app-multipane-resizer>
      <!--
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4" xl="4" v-show="showRules || !horizontal_effects_view">
      -->
      <div class="pane" :style="{ flexGrow: 1, minWidth: '100px', width: $vuetify.breakpoint.mdAndUp ? '25%' : '100%'}" v-show="showRules || !horizontal_effects_view">
        <div v-show="showRules && horizontal_effects_view">
          <bank-rules v-if="currentCompany && currentBankAccount" :company_id="currentCompany.id" :num_digits="currentCompany.num_digits" :work_with_effects="currentBankAccount.work_with_effects"></bank-rules>
        </div>
        <bank-pending-effects-table
          v-if="got_feature('feature_can_use_payable_or_receivable_effects') && currentBankAccount && currentBankAccount.work_with_effects && !horizontal_effects_view"
          :selectedEffects="selectedEff" :selectedTransactionsP="selectedTr"
          @updateE="handleSelectedEffects" @updateT="handleSelectedTransactions"
          @toggleSplitView="toggleSplitView" ref="pendingEffectsTable"></bank-pending-effects-table>
      </div>
      <!--
      </v-col>
    </v-row>
    -->
    </app-multipane>          
  </v-container>
</template>
<script>
import BankAccountDetail from "@/components/BankAccountDetail.vue";
import BankPendingEffectsTable from "@/components/BankPendingEffectsTable.vue";
import BankRules from "@/components/BankRules.vue";
import { mapState, mapGetters } from 'vuex';
import { BankAccountQuery } from "@/modules/bank/application/BankAccountQuery";
import { query_dispatcher } from "@/api/client";
import AppMultipane from "@/components/layout/AppMultipane.vue";
import AppMultipaneResizer from "@/components/layout/AppMultipaneResizer.vue"

export default {
  name: 'BankTransactionList',
  props: {
    bank_account_id: {
      type: String,
    },
  },
  components: {  
    BankAccountDetail,
    BankRules,
    BankPendingEffectsTable,
    AppMultipane,
    AppMultipaneResizer
  },
  computed: {
    ...mapState(['currentCompany']),    
    ...mapGetters({      
      permission: 'permissions/permission',
      got_feature:'got_feature',
    }),
  },
  data() {
    return {
      showRules: true,
      currentBankAccount:undefined,
      horizontal_effects_view: true,
      selectedTr:[],
      selectedEff:[],
    }
  },
  
  async mounted() {
    try { 
        await new BankAccountQuery(query_dispatcher, this).run(this.bank_account_id);
    } catch (error) {
        console.error('Error getting bank account', error);                
    }  
  },
  methods: {
    setEffectsVisibility(work_with_effects) {
      this.currentBankAccount = {
        ...this.currentBankAccount,
        work_with_effects: work_with_effects
      };
    },
    toggleShowRules(showRules) {
      this.showRules = showRules;
      if (this.showRules) {
        this.horizontal_effects_view = true;
      }
    },  
    toggleSplitView() {
      this.horizontal_effects_view = !this.horizontal_effects_view;      
    },
    handleSelectedTransactions(tr) {
      this.selectedTr = tr;
    },
    handleSelectedEffects(eff) {
      this.selectedEff = eff;
    },
    handleRefreshEffects() {
      this.$refs.pendingEffectsTable.refreshEffects()
    }
  }
}
</script> 

<style scoped>
  .split-panes {
  width: 100%;
  height: auto;
  min-height:100%;
  /*
  height: 400px;
  border: 1px solid #ccc;
  background-color: white;
  */
}

.split-panes > .pane {
  text-align: left;
  /*padding: 10px;*/
  overflow: hidden;
  /*background: #eee;*/
}

.split-panes > .pane ~ .pane {
  /*border-left: 1px solid #ccc;*/
}



@media screen and (max-width: 960px) {
  .split-panes.layout-v {
    flex-direction:column !important;
  }
  .split-panes > .pane {
    margin-top:10px;
  }
  .split-panes .multipane-resizer {
    display:none;
  }
}
</style>